import dayjs from 'dayjs'
import {
  AgxRow,
  AgxColumn,
  AgxDatePicker,
  AgxErrorLabel,
} from '@urbanx/agx.ui-components2'

export interface AppointmentPeriodValue {
  startDate?: Date
  endDate?: Date
}

export const AppointmentPeriod = ({
  value,
  onChange,
}: {
  value: AppointmentPeriodValue
  onChange: (updated: Partial<AppointmentPeriodValue>) => void
}) => {
  const { startDate, endDate } = value

  const update = (updated: Partial<AppointmentPeriodValue>) => {
    onChange(updated)
  }

  return (
    <AgxRow gap="spacing-lg" fill>
      <AgxRow  fill>
        <AgxColumn gap="spacing-md" fill>
          <AgxDatePicker
            id="agreementStartDate"
            label="Start Date"
            value={startDate ?? undefined}
            required
            stretch
            onChange={(d: Date | null) =>
              update({
                startDate: d ?? undefined,
              })
            }
            optionalText=""
          />

          {!startDate && (
            <AgxErrorLabel
              id="startDateError"
              errorText="The start date is required"
            />
          )}
        </AgxColumn>
      </AgxRow>

      <AgxRow  fill>
        <AgxColumn gap="spacing-md" fill>
          <AgxDatePicker
            id="agreementEndDate"
            label="End Date"
            required
            optionalText=""
            stretch
            value={endDate ?? undefined}
            onChange={(d: Date | null) =>
              update({
                endDate: d ?? undefined,
              })
            }
          />

          {startDate &&
            endDate &&
            dayjs(endDate).diff(dayjs(startDate), 'day') < 0 && (
              <AgxErrorLabel
                id="invalidDates"
                errorText="The end date should be after start date"
              />
            )}

          {!endDate && (
            <AgxErrorLabel
              id="endDateError"
              errorText="The end date is required"
            />
          )}
        </AgxColumn>
      </AgxRow>
    </AgxRow>
  )
}

export default AppointmentPeriod
